import React from 'react';
import PropTypes from 'prop-types';

const Logout = ({ color = '#8C949C' }) => (
    <svg
        width="22px"
        height="22px"
        viewBox="0 0 22 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Svg-Icons/18px-(All-icons)/Menu/logout-filled"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <path
                d="M9.09,14.59 L10.5,16 L15.5,11 L10.5,6 L9.09,7.41 L11.67,10 L2,10 L2,12 L11.67,12 L9.09,14.59 Z M18,2 L4,2 C2.89,2 2,2.9 2,4 L2,8 L4,8 L4,4 L18,4 L18,18 L4,18 L4,14 L2,14 L2,18 C2,19.1 2.89,20 4,20 L18,20 C19.1,20 20,19.1 20,18 L20,4 C20,2.9 19.1,2 18,2 Z"
                id="Shape"
                fill={color}
                className="icon-color"
            />
        </g>
    </svg>
);

Logout.propTypes = {
    color: PropTypes.string,
};

export default Logout;
